export default __webpack_public_path__ + "static/media/profile-hospital.5d12e692.svg";